import {SchemeLink} from '../../../applink/SchemeLink';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {timeago} from '../../../date/timeago';
import {Button} from '../../atoms/Button/Button';
import {ButtonColorScheme, ButtonSize} from '../../atoms/Button/Button.enum';
import {Dot} from '../../atoms/Dot/Dot';
import {Image} from '../../atoms/Image/Image';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {Text} from '../../atoms/Text/Text';
import {ThumbnailRatio} from '../../molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../molecules/ThumbnailWithBadges/ThumbnailType.enum';
import {NOTI_THUMBNAIL_IMAGE_MAP} from './constants';
import {NotificationItemProps} from './NotificationItemProps.interface';
import {NotiThumbnailType} from './NotiThumbnailType.enum';

export function NotificationItem({
  title,
  message,
  date,
  thumbnail,
  thumbnailType,
  hasDot,
  canRemove,
  onClickNotificationItem,
  onClickRemove,
  scheme,
  className,
  ...props
}: NotificationItemProps) {
  const shouldShowThumbnail =
    thumbnailType === NotiThumbnailType.ProductThumbnail ||
    (thumbnailType === NotiThumbnailType.ThumbnailOrDefault && thumbnail);
  return (
    <div
      className={twMerge('flex w-full items-center py-12pxr', className)}
      onClick={onClickNotificationItem}
      {...props}
    >
      <SchemeLink
        scheme={scheme || undefined}
        linkClassName="flex flex-1 items-center"
      >
        {shouldShowThumbnail && (
          <div className="relative flex h-80pxr w-56pxr shrink-0 items-center justify-center overflow-hidden rounded-3pxr">
            <Image
              src={thumbnail || undefined}
              alt="썸네일 이미지"
              ratio={ThumbnailRatio[ThumbnailType.Poster]}
              className="w-full"
            />
            {/* 썸네일 보더 */}
            <div className="absolute top-0 left-0 h-full w-full rounded-3pxr border-0.5 border-solid border-static-transparent-black-05" />
          </div>
        )}
        {!shouldShowThumbnail && (
          <div
            className={twMerge(
              'flex h-56pxr w-56pxr shrink-0 items-center justify-center overflow-hidden rounded-full bg-theme-solid-10',
              (thumbnailType === NotiThumbnailType.Default ||
                thumbnailType === NotiThumbnailType.ThumbnailOrDefault) &&
                'bg-static-point-yellow'
            )}
          >
            <StaticImage
              imageType={NOTI_THUMBNAIL_IMAGE_MAP[thumbnailType]}
              className="w-full"
            />
          </div>
        )}
        <div className="ml-12pxr flex flex-1 flex-col">
          <Text className="font-medium2 relative mb-4pxr inline-block w-fit-content break-all text-theme-solid-100">
            {title}
            {hasDot && <Dot className="absolute top-0 -right-6pxr" />}
          </Text>
          <Text className="font-small1 mb-8pxr inline-block text-theme-solid-60">
            {message}
          </Text>
          <Text className="font-small2 inline-block text-theme-solid-40">
            {timeago({date})}
          </Text>
        </div>
      </SchemeLink>
      {canRemove && (
        <div className="ml-12pxr flex shrink-0 items-center justify-center">
          <Button
            size={ButtonSize.Small}
            colorScheme={ButtonColorScheme['3rd']}
            onClick={event => {
              event.stopPropagation();
              if (onClickRemove) {
                onClickRemove(event);
              }
            }}
          >
            {t('common_delete_button')}
          </Button>
        </div>
      )}
    </div>
  );
}
